export default class UploadManager {

  _queue = [];
  _urls = [];

  add(upload) {
    this._queue.push(upload);
    if (this._queue.length === 1) {
      upload.start();
    } else {
      const uploadInProgress = this._queue.filter(u => u.xhr !== null && u !== 'FINISHED')[0];
      if (!uploadInProgress) {
        this._startNextUpload();
      }
    }
  }

  remove(upload) {
    const index = this._queue.indexOf(upload);
    const wasInProgress = upload.xhr !== null;
    if (index === -1) {
      return;
    }

    if (wasInProgress) {
      this._queue.splice(index, 1);
      setTimeout(() => this._startNextUpload(), 100);
    }
  }

  addUrl(url) {
    this._urls.push(url);
  }

  _startNextUpload() {
    const nextUpload = this._queue.filter(u => u.xhr === null && !u.aborted)[0];
    if (nextUpload) {
      nextUpload.start();
    }
  }

  clear() {
    this._queue = [];
    this._urls = [];
  }

}
